import React, { useState } from 'react'
import { useEffect } from 'react'
import { htmlToText, trimString, tokenAuthorize } from '../../components/Helpers/Common'
import { staticFiles } from '../../components/Helpers/Static';
import { serverUrl } from '../../components/Helpers/Config';
import axios from "axios";

const NO_IMAGE = staticFiles.noImage;

function ShareExport({ item, idx, add, remove, isShow }) {
    const [check, setCheck] = useState(false)
    const [profile,setProfile] = useState(null)

    function handleChange() {
        // setCheck(!check)
        if (isShow?.length > 0) {
            remove(item.id)
        } else {
            add(item.id)
        }
    }

    useEffect(() => {
        if (isShow === false) {
            setCheck(false)
        }
    }, [isShow])

    useEffect(()=>{
        let guid= item.user_link.replace('/profile/','');
        axios.get(serverUrl.ShowcaseGalleryImage + guid).then(res => {
            setProfile(res.data?.profile_image);
        }).catch(err => {
            tokenAuthorize(err?.response?.status);
            console.log(err)
          })
    },[item])

    let style = (check ? 'bg-blue' : '')
    style += ' appearance-none rounded-full w-full h-full'

    // const CheckBox = () => {

    //     return (
    //         <div className='border-2 border-black rounded-full w-8 h-8 p-1'>
    //             <input type='checkbox' className={style} onChange={handleChange} />
    //         </div>
    //     )
    // }

    return (
        <div className='flex w-full flex-row justify-around' style={{ height: '45px' }}>
            <div className='flex flex-row w-full'>
                <p className='font-semibold mr-5'>{idx + 1}</p>
                <div className='flex flex-col ml-2 md:flex-row'>
                    <div className=' overflow-hidden'>
                        <img
                            src={profile ? profile : NO_IMAGE}
                            alt="postImage"
                            className='w-10 h-10  object-cover rounded-full'
                            onError={(e) => { e.target.src = NO_IMAGE }}
                        />
                    </div>
                    <div className='w-40 md:w-60 pr-5'>
                        <div className='md:px-5 mb-4 align-middle font-bold'>
                            {item.user_name}
                        </div>
                    </div>

                </div>

            </div>
            <div className='flex'>
                <input type='checkbox' className='w-6 h-6 rounded cursor-pointer' onChange={handleChange} checked={isShow?.length > 0 ? true : false} />
            </div>
        </div>
    )
}

export default ShareExport
